$(".toggle-header-search").click(function(){
    $(".search").toggleClass("active");
})